import { Component } from '@angular/core';

@Component({
  selector: 'app-citation-guide',
  templateUrl: './citation-guide.component.html',
  styleUrls: ['./citation-guide.component.scss']
})
export class CitationGuideComponent {

}
